<!--
 * @Author: Lemon C
 * @Date: 2025-01-15 12:11:09
 * @LastEditTime: 2025-01-17 11:18:44
-->
<template>
    <div class="sup-performance">
        <div class="re-w1200 re-main-col">
            <div class="top-box">
                <span class="top-title">超强性能</span>
                <span class="top-dis">近乎无上限的模型承载，TB级数据极速加载</span>
            </div>
            <div class="grid-list-box">
                <div class="grid-item-box" v-for="(item, index) in proformance_list" :key="`item_${index}`">
                    <div class="item-line"></div>
                    <div class="item-title-box">
                        <span class="item-title">{{ item.title }}</span>
                        <span class="item-second-title">{{ item.secondTitle }}</span>
                    </div>
                    <span class="item-dis">{{ item.dis }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref } from 'vue';

const proformance_list = ref([
    {
        title: '60',
        secondTitle: 'fps',
        dis: '极致丝滑的网页端视觉盛宴',
    },
    {
        title: '100亿',
        secondTitle: '+',
        dis: '超百亿三角面片同屏加载',
    },
    {
        title: '10TB',
        secondTitle: '+',
        dis: '全类型三维数据同步加载',
    },
    {
        title: '5.1亿',
        secondTitle: '平方公里',
        dis: '全球范围影像+高程数据渲染',
    },
    {
        title: '100TB',
        secondTitle: '+OSGB',
        dis: '多终端跨平台极速流畅体验',
    },
    {
        title: '10000万',
        secondTitle: '+',
        dis: '上亿构件全方位业务管理',
    },
]);
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-performance {
    position: relative;
    display: flex;
    justify-content: center;

    .top-box {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;

        .top-title {
            position: relative;
            height: 60px;
            font-weight: 500;
            font-size: 40px;
            color: var(--color-main-text-primary);
            line-height: 47px;
            display: flex;
            align-items: center;
        }

        .top-dis {
            position: relative;
            margin-top: 32px;
            width: 100%;
            min-height: 36px;
            max-height: 88px;
            font-weight: 400;
            font-size: 24px;
            color: var(--color-main-text-secondary);
            line-height: 44px;
            text-align: center;
            font-style: normal;
        }
    }

    .grid-list-box {
        position: relative;
        width: 100%;
        margin-top: 60px;
        flex-shrink: 0;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        column-gap: 35px;
        row-gap: 60px;

        .grid-item-box {
            position: relative;
            display: flex;
            height: 140px;
            flex-direction: column;
            justify-content: flex-end;

            .item-line {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 1px;
                background-color: var(--color-main-home-performance-line);
            }

            .item-title-box {
                position: relative;
                display: flex;
                align-items: flex-end;

                .item-title {
                    position: relative;
                    font-weight: bold;
                    font-size: 40px;
                    color: var(--color-main-text-primary);
                    line-height: 40px;
                }

                .item-second-title {
                    position: relative;
                    font-weight: bold;
                    font-size: 25px;
                    color: var(--color-main-text-home-secondary);
                    line-height: 25px;
                }
            }

            .item-dis {
                position: relative;
                margin-top: 18px;
                font-weight: 400;
                font-size: 23px;
                color: var(--color-main-text-home-dis);
                line-height: 25px;
            }
        }
    }
}
</style>
